import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db384202"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "shop-info-content-div" }
const _hoisted_3 = { class: "info-card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-icon" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M3 9L12 2L21 9V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M9 21V12H15V21",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "header-text" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "小店信息"),
    /*#__PURE__*/_createElementVNode("p", null, "管理您的小店基本信息与配置")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "info-box url-box"
}
const _hoisted_6 = { class: "box-icon" }
const _hoisted_7 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"18px","height":"18px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M10 13C9.4 13 9 13.4 9 14C9 15.3 8.3 16 7 16C5.7 16 5 15.3 5 14C5 13.4 4.6 13 4 13C3.4 13 3 13.4 3 14C3 16.4 4.6 18 7 18C9.4 18 11 16.4 11 14C11 13.4 10.6 13 10 13Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14 11C14.6 11 15 10.6 15 10C15 8.7 15.7 8 17 8C18.3 8 19 8.7 19 10C19 10.6 19.4 11 20 11C20.6 11 21 10.6 21 10C21 7.6 19.4 6 17 6C14.6 6 13 7.6 13 10C13 10.6 13.4 11 14 11Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "box-content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-label" }, "小店访问地址", -1))
const _hoisted_13 = { class: "box-value" }
const _hoisted_14 = { class: "box-action" }
const _hoisted_15 = { class: "info-box balance-box" }
const _hoisted_16 = { class: "box-icon" }
const _hoisted_17 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"18px","height":"18px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "box-content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-label" }, "账户余额", -1))
const _hoisted_22 = { class: "box-value" }
const _hoisted_23 = {
  key: 1,
  class: "pay-mode-notice"
}
const _hoisted_24 = { class: "notice-icon warning" }
const _hoisted_25 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"18px","height":"18px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 9V13M12 17H12.01M5.07 19H18.93C20.47 19 21.44 17.33 20.66 16L13.73 4C12.96 2.67 11.04 2.67 10.27 4L3.34 16C2.56 17.33 3.53 19 5.07 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("当前小店为"),
  /*#__PURE__*/_createElementVNode("strong", null, "自定义支付通道"),
  /*#__PURE__*/_createTextVNode("，游客访问小店后，将使用您自定义的支付通道进行支付，请确保余额充足，否则即使支付成功，余额支付开通授权时也会失败。 ")
], -1))
const _hoisted_29 = {
  key: 2,
  class: "pay-mode-notice"
}
const _hoisted_30 = { class: "notice-icon info" }
const _hoisted_31 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"18px","height":"18px"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16ZM12 8V12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("当前小店为"),
  /*#__PURE__*/_createElementVNode("strong", null, "系统支付通道"),
  /*#__PURE__*/_createTextVNode("，游客访问小店后，将使用系统支付通道进行支付，您自定义的支付通道不会生效，游客支付授权成功后，将发放反利给您。 ")
], -1))
const _hoisted_35 = { class: "form-section" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-section-title" }, "基本设置", -1))

import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopInfoView',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const shopInfo = ref({
    id: 0,
    tenant_key: '',
    shop_name: '',
    shop_status: 1,
    shop_desc: '',
    contact: '',
    balance: 0,
    order_pay_mode: '',
})
const saving = ref(false)
const isAdmin = ref(false)

const shopUrl = computed(() => {
    if (!shopInfo.value.tenant_key) return ''
    const origin = window.location.origin
    return `${origin}/shop?tenant_key=${shopInfo.value.tenant_key}`
})

const getShopInfo = async () => {
    try {
        const res = await axios.post(baseURL + '/api/shop/tenant/info', {}, { headers })
        if (res.data.code === 0) {
            shopInfo.value = { ...shopInfo.value, ...res.data.data }
            isAdmin.value = !!res.data.data.is_admin
        } else {
            ElMessage.error(res.data.msg || '获取小店信息失败')
        }
    } catch (e: any) {
        ElMessage.error('获取小店信息失败：' + e.message)
    }
}

const saveShopInfo = async () => {
    saving.value = true
    try {
        const res = await axios.post(baseURL + '/api/shop/tenant/update', {
            shop_name: shopInfo.value.shop_name,
            shop_status: shopInfo.value.shop_status,
            shop_desc: shopInfo.value.shop_desc,
            contact: shopInfo.value.contact,
            ...(isAdmin.value ? { order_pay_mode: shopInfo.value.order_pay_mode } : {}),
        }, { headers })
        if (res.data.code === 0) {
            ElMessage.success('保存成功')
        } else {
            ElMessage.error(res.data.msg || '保存失败')
        }
    } catch (e: any) {
        ElMessage.error('保存失败：' + e.message)
    } finally {
        saving.value = false
    }
}

const copyText = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
        ElMessage.success('已复制到剪贴板')
    }).catch(() => {
        ElMessage.warning('复制失败，请手动复制')
    })
}

const openShop = () => {
    window.open(shopUrl.value, '_blank')
}

onMounted(() => {
    getShopInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, { style: {"width":"fit-content"} }, {
          default: _withCtx(() => [
            _createVNode(UserHead)
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { style: {"padding":"0"} }, {
              default: _withCtx(() => [
                _createVNode(UserHeadTop)
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, { style: {"padding-top":"0","height":"100vh","overflow":"hidden","padding-left":"0","background-color":"transparent"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    (shopInfo.value.tenant_key)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, _toDisplayString(shopUrl.value), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_el_button, {
                              size: "small",
                              type: "success",
                              plain: "",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (copyText(shopUrl.value)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("复制")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "small",
                              type: "primary",
                              plain: "",
                              onClick: openShop
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("打开")
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, "￥" + _toDisplayString(shopInfo.value.balance || '0.00'), 1)
                      ])
                    ]),
                    (shopInfo.value.order_pay_mode === 'tenant')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_27))
                          ]),
                          _hoisted_28
                        ]))
                      : (shopInfo.value.order_pay_mode === 'system')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_33))
                            ]),
                            _hoisted_34
                          ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode(_component_el_form, {
                        model: shopInfo.value,
                        "label-width": "90px",
                        "label-position": "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "小店名称" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: shopInfo.value.shop_name,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shopInfo.value.shop_name) = $event)),
                                placeholder: "请输入小店名称"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "小店状态" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_switch, {
                                modelValue: shopInfo.value.shop_status,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shopInfo.value.shop_status) = $event)),
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-text": "营业中",
                                "inactive-text": "已关闭"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "小店简介" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: shopInfo.value.shop_desc,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shopInfo.value.shop_desc) = $event)),
                                type: "textarea",
                                rows: 3,
                                placeholder: "请输入小店简介"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "联系方式" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: shopInfo.value.contact,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((shopInfo.value.contact) = $event)),
                                placeholder: "请输入联系方式（如QQ、微信、邮箱等）"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (isAdmin.value)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: "支付模式"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: shopInfo.value.order_pay_mode,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shopInfo.value.order_pay_mode) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio, { value: "tenant" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("自定义支付通道")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_radio, { value: "system" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("系统支付通道")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                class: "save-btn",
                                onClick: saveShopInfo,
                                loading: saving.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 保存修改 ")
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})